import { Heart, Shield, ScrollText } from 'lucide-react';

export function Footer() {
  return (
    <footer className='border-t bg-background/95 backdrop-blur-sm mt-auto'>
      <div className='container mx-auto px-4 py-6 lg:px-8'>
        <div className='flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground'>
          <div className='flex items-center gap-1'>
            <span>Built with</span>
            <Heart className='h-4 w-4 text-red-500 fill-red-500' />
            <span>by</span>
            <a
              href='https://kocmouch.xyz'
              target='_blank'
              rel='noopener noreferrer'
              className='font-medium text-foreground hover:text-primary transition-colors'
            >
              Kocmouch
            </a>
          </div>

          <div className='flex items-center gap-4'>
            <button
              onClick={() => {
                window.location.hash = '/changelog';
              }}
              className='flex items-center gap-1.5 hover:text-primary transition-colors'
            >
              <ScrollText className='h-4 w-4' />
              <span>Changelog</span>
            </button>

            <span className='text-muted-foreground/50'>•</span>

            <button
              onClick={() => {
                window.location.hash = '/privacy';
              }}
              className='flex items-center gap-1.5 hover:text-primary transition-colors'
            >
              <Shield className='h-4 w-4' />
              <span>Privacy Policy</span>
            </button>

            <span className='text-muted-foreground/50'>•</span>

            <span>© 2026 Kocmouch</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
